import { render } from "./refwechatinfo.vue?vue&type=template&id=6868bc94&scoped=true"
import script from "./refwechatinfo.vue?vue&type=script&lang=js"
export * from "./refwechatinfo.vue?vue&type=script&lang=js"

import "./refwechatinfo.vue?vue&type=style&index=0&id=6868bc94&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6868bc94"]])

export default __exports__